define(["../occurrenceCategoryModule",
        "json!../../monitoring.json",
        "json!../../tdnByEntity.json"],
    function (occurrenceCategoryModule, monitoring, tdnByEntity) {
        "use strict";

        return occurrenceCategoryModule.controller("OccurrenceCategorySearchController", [
            "$scope",
            "$q",
            "monitoringService",
            "reload",
            "loadingService",
            "remoteExceptionHandler",
            "occurrenceCategoryService",
            "tdnHelp",
            function ($scope, $q, monitoringService, reload, loadingService, remoteExceptionHandler, occurrenceCategoryService, tdnHelp) {
                $scope.serviceName = monitoring.services.occurrenceCategoriesFilter;
                var template, paginationApi, paginationApiDefer = $q.defer();
                var filterApi, filterApiDefer = $q.defer();

                $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["occurrence-category"]

                $scope.search = function (modifiedTemplate) {
                    template = modifiedTemplate;
                    paginationApi.seekPage(1);
                };

                $scope.onRegisterFilterApi = function (api) {
                    filterApi = api;
                    filterApiDefer.resolve();
                };

                $q.all([paginationApiDefer.promise, filterApiDefer.promise]).then(function () {
                    filterApi.onChangeService(function (service) {
                        if (service === $scope.serviceName) {
                            if (reload) {
                                filterApi.reload();
                            } else {
                                filterApi.reset();
                            }
                        }
                    });
                });

                $scope.tableOptions = {
                    records: [],
                    pagination: {
                        onPaginate: function (firstResult, maxResults) {
                            return loadingService(monitoringService.filterOccurrenceCategories("/filter", template, firstResult, maxResults))
                                .then(function (result) {
                                    return result;
                                }).catch(remoteExceptionHandler());
                        }
                    },
                    onRegisterPagination: function (api) {
                        paginationApi = api;
                        paginationApiDefer.resolve();
                    }
                };

                $scope.delete = function (id) {
                    return occurrenceCategoryService.deleteOccurrenceCategory(id)
                        .finally(function () {
                            filterApi.reload();
                        });
                };
            }]);
    });